<template>
  <div class="container">
    <div class="row">
      <div class="overviewAndNav mb-1">
        <h3>Profiel van {{ profile.firstName }}
          {{ profile.lastName }}</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 text-right">
        <div class="text-left d-inline-block">
          <p>Id</p>
          <p>Werknemersnummer</p>
          <p>Email</p>
          <p>Voornaam</p>
          <p>Achternaam</p>
          <p>Deeltijds percentage</p>
          <p>Opgebouwde recuperatie</p>
          <p>Duur absentiedag</p>
        </div>
      </div>
      <div class="col-lg-6 text-left">
        <p>{{ profile.id }}</p>
        <p>{{ getEmployeeNumberText() }}</p>
        <p>{{ profile.email }}</p>
        <p>{{ profile.firstName }}</p>
        <p>{{ profile.lastName }}</p>
        <p>{{ profile.partTimePercentage }}</p>
        <p>{{ profile.recup | convertDotToCommaInNumber }} uren,
          bevestigd voor {{ profile.recupConfirmedYearMonth | toMonthNameWithYear }}</p>
        <p>{{ profile.sickDayHours }} </p>
      </div>
    </div>

    <div class="row d-block">
      <h5 class="mt-5">Contracten</h5>
    </div>

    <div class="row mt-4">
      <table class="table">
        <thead class="thead-dark">
        <tr>
          <SortableTableHeaderComponent
              columnName="id" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Contract id"/>
          <SortableTableHeaderComponent
              columnName="customerId" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Klant id"/>
          <SortableTableHeaderComponent
              columnName="customerName" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Klantnaam"/>
          <SortableTableHeaderComponent
              columnName="contractPeriod" :sortColumn="currentSortColumn"
              :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
              text="Contract periode"/>
        </tr>
        </thead>
        <tbody>
        <tr :key="contractSummaryDto.id" v-for="contractSummaryDto in sortedContracts">
          <td>{{ contractSummaryDto.id }}</td>
          <td>{{ contractSummaryDto.customerId }}</td>
          <td>{{ contractSummaryDto.customerName }}</td>
          <td>{{ contractSummaryDto.contractPeriod.startDate }}
            {{
              contractSummaryDto.contractPeriod.endDate ? " tot " + contractSummaryDto.contractPeriod.endDate : "(met onbepaalde duur)"
            }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {sortListByColumnAndDirection} from "@/util/SortingUtil";
import SortableTableHeaderComponent from "@/components/tables/SortableTableHeader";

export default {
  name: "UserProfile",
  components: {SortableTableHeaderComponent},
  data: () => ({
    currentSortColumn: "contractPeriod",
    currentSortDirectionAscending: true,
  }),
  computed: {
    ...mapGetters({
      profile: "user/profile"
    }),
    sortedContracts() {
      const contracts = [...this.profile.contractSummaryDtos || []];
      if (this.currentSortColumn === "contractPeriod") {
        if (this.currentSortDirectionAscending) {
          return contracts;
        }
        return contracts.reverse();
      }
      return sortListByColumnAndDirection(contracts, this.currentSortColumn, this.currentSortDirectionAscending);
    }
  },
  async created() {
    await this.fetchProfile();
  },
  methods: {
    ...mapActions("user", ["fetchProfile"]),
    getEmployeeNumberText() {
      if (this.profile.employeeNr || this.profile.employeeNr === 0) {
        return this.profile.employeeNr;
      }
      return "Je hebt geen werknemersnummer";
    },
    sort: function (newSortColumn) {
      if (newSortColumn === this.currentSortColumn) {
        this.currentSortDirectionAscending = !this.currentSortDirectionAscending;
      } else {
        this.currentSortDirectionAscending = true;
      }
      this.currentSortColumn = newSortColumn;
    }
  }
};
</script>

<style scoped>
</style>